import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CardModule } from '@modules/card/card.module';
import { MediaModule } from '@modules/media/media.module';
import { PipesModule } from '@modules/pipes/pipes.module';
import { UiModule } from '@modules/ui/ui.module';

import { FavoriteCardComponent } from './favorite-card/favorite-card.component';
import { FavoritesModalComponent } from './favorites-modal/favorites-modal.component';

@NgModule({
  imports: [
    CommonModule,
    CardModule,
    PipesModule,
    UiModule,
    TranslatePipe,
    MediaModule,
    FavoritesModalComponent,
    FavoriteCardComponent,
  ],
  exports: [FavoritesModalComponent],
})
export class FavoritesModule {}
